<script>
  import { onMount } from "svelte";
  import { changeToken } from "../../../Api";
  import { api } from "../../../helpers";
  import GeneralLayout from "../../layouts/GeneralLayout.svelte";
  import Comments from '../../custom/Comments/Comments.svelte';
  import Card from './components/Card/Card.svelte';
  import PublicateItem from "../Publicate/PublicateItem.svelte";

  export let params = {};

  let topicInfo = null;

  const getTopicInfo = async () => {
    const response = await api(`/api/v1/publication/retrive/${params.id}/`);
    const publication = await response.json();

    if (!response.ok) {
      changeToken(response.status);
      return null;
		}

    return publication;
  }

  onMount(async () => {
    topicInfo = await getTopicInfo();
  });
</script>

{#if topicInfo}
  <GeneralLayout isShowBackButton fixBottomPanel>
    <Card 
      title={topicInfo.title}
      preview_text={topicInfo.preview_text}
    />

    {#each topicInfo.publication_items as item}
      <PublicateItem {...item} id_publicate={params.id} />
    {/each}

    <Comments 
      id_publicate={params.id}
      disable_comments={topicInfo.disable_comments} 
    />
  </GeneralLayout>
{/if}